/*  西班牙语包  */
import xbyLocale from 'element-ui/lib/locale/lang/es'
const xby = {
    message: {
        /*  导航栏语言设定 */
        'headerMenu' : 'Disco en la nube',
        'headerlangSelect' : 'Por favor seleccione un idioma',
        'headerLoginOut' : 'Cerrar sesión',

        /*  侧边栏语言设定 */
        'sideMenuFileName' : 'Todos los archivos',
        'sideMenuPhoto' : 'Imágenes',
        'sideMunsDoc' : 'Archivo',
        'sideMenuVideo' : 'Video',
        'sideMenuSeed' : 'Semilla',
        'sideMenuMusic' : 'Musica',
        'sideMenuOrther' : 'Otros',
        'sideMenuShareName' : 'Mi parte',
        'sideMenuCollectName' : 'Papelera de reciclaje',

        /*  用户语言设定 */
        'mainUpload' : 'Subir',
        'mainBuildDir' : 'Nueva carpeta',
        'mainDownloadOutline' : 'Descargar sin conexión',
        'mainSearch' : 'Búsqueda de archivos',
        'mainAllFile' : 'Todos los archivos',
        'mainFile' : 'Archivo',
        'mainSize' : 'Tamaño',
        'mainDate' : 'Fecha',
        'mainFileDel' : 'Eliminar',
        'mainConfirmDel' : 'Confirmar eliminar?',
        'sure' : 'Confirmar',
        'cancel' : 'Cancelar',
        'mainReturn' : 'Volver a',
        'mainPagePrev' : 'Anterior',
        'mainPageNext' : 'Página siguiente',
        'mainLoaded' : 'Cargado',
        'mainTotal' : 'Total',
        'mainUnit' : 'Tira',
        'dilatation' : 'Expansión',
        /*  回收站设定  */
        'mainHeaderTitle' : 'Consejo: La papelera de reciclaje no ocupa espacio en el disco de la red.',
        'mainHeaderButton' : 'Papelera de reciclaje vacía',
        'collectName' : 'Papelera de reciclaje',
        'mainRevertIts' : 'Restaurar',
        'mianDelData' : 'Eliminar hora',

        'confirmClear' : '¿Confirmar para borrar los archivos seleccionados? (No se puede recuperar después de borrar)',
        'confirmClearAll' : '¿Seguro que quieres vaciar la papelera de reciclaje?',

        /*  其他设定 */
        'messageBoxTitle' : 'Pista',
        'messageBoxConfirmRevert' : '¿Confirmar para restaurar el archivo seleccionado?',
        'loading' : 'Cargando ...',
        'loaded' : 'Sin datos',

        'messageMoveTo' : 'Mover a',
        'filterNotice' : 'Ingrese palabras clave para filtrar',
        'messageLoaded' : 'Descargado:',
        'messageMovetion' : 'Movimiento de archivo',

        'messageMissKeyWord' : 'Por favor, introduzca palabras clave de búsqueda',
        'messageFolderLayersLimit' : 'Creación fallida La profundidad de la jerarquía de carpetas no supera los 5 niveles.',
        'messageSameFolderName' : 'Creación fallida El mismo nombre de archivo existe',
        'messageEmptyFolderName' : 'Por favor ingrese un nombre de carpeta',
        'messageMoveSame' : 'No se puede mover a la misma carpeta',
        'messageActionError' : 'Operación fallida',
        'messageActionSuccess' : 'Operación exitosa',
        'messageServerIsBusy' : 'El servidor está ocupado',
        'messageUploadOverLimit' : 'Demasiados archivos seleccionados (dentro de 5)',
        'messageDiskFreeFull' : 'Espacio de usuario insuficiente',
        'messageUploadTypeError' : 'No se puede cargar este tipo de archivo',
        'messageUploadMaxSize' : 'El archivo de carga es demasiado grande (dentro de 10M)',
        'messageUploadSuccess' : 'Subido correctamente',
        'messageUploadFailed' : 'Carga fallida',
        'messageDownloadFailed' : 'Descarga fallida'
    },
    ...xbyLocale
};

export default xby;



// WEBPACK FOOTER //
// ./src/i18n/langs/xby.js